import React, { useState } from 'react';
import ProductsNavRow from '../rownavigator';

const TilingFlooring = () => {
  // State management
  const [activeCategory, setActiveCategory] = useState("tiling_flooring");
  const [activeSubcategory, setActiveSubcategory] = useState(null);
  const [activeOption, setActiveOption] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Data structure
  const tiling_flooring = {
    tiling_flooring: {
      name: "Technical Flooring",
      subcategories: {
        tiles: {
          name: "Tiles",
          options: {
            decorative: {
              name: "Decorative Tiles",
              options: {
                wall_tiles: {
              name: "Wall Tiles",
              products: [
                {
                  name: "Ceramic Subway Tiles",
                  image: "/assets/productimages/walltiles.jpg",
                  use: "Internal and External Wall covering",
                  details: "7.5x15cm, glossy finish",
                  price: ""
                }
              ]
            },
            floor_tiles: {
              name: "Floor Tiles",
              products: [
                {
                  name: "Premium Floor Tiles",
                  image: "/assets/productimages/tile1.jpeg",
                  use: "High-traffic floor surfaces",
                  details: "Durable porcelain/ceramic finish",
                  price: ""
                }
              ]
            },
                patterned: {
                  name: "Patterned Tiles",
                  products: [
                    {
                      name: "Encaustic Cement Tiles",
                      image: "/assets/productimages/patterntiles.jpg",
                      use: "Decorative surface covering",
                      details: "20x20cm, traditional pattern",
                      price: ""
                    }
                  ]
                },
                mosaic: {
                  name: "Mosaic Tiles",
                  products: [
                    {
                      name: "Glass Mosaic Sheets",
                      image: "/assets/productimages/mosaictiles.avif",
                      use: "Artistic surface covering",
                      details: "30x30cm mesh-mounted",
                      price: ""
                    }
                  ]
                }
              }
            },
            vinyl: {
              name: "Vinyl Flooring",
              options: {
                sheet_vinyl: {
                  name: "Vinyl Sheet",
                  products: [
                    {
                      name: "Wood Effect Vinyl",
                      image: "/assets/productimages/vinyli.jpg",
                      use: "Versatile floor covering",
                      details: "2m wide roll, 2mm thickness",
                      price: ""
                    }
                  ]
                },
                floating: {
                  name: "Vinyl Planks",
                  products: [
                    {
                      name: "Click Vinyl Planks",
                      image: "/assets/productimages/floatingflooring.jpg",
                      use: "Easy-install floor covering",
                      details: "Click-lock system, durable design",
                      price: ""
                    }
                  ]
                }
              }
            },
            carpet_tiles: {
              name: "Carpet Tiles",
              products: [
                {
                  name: "Office Carpet Tiles",
                  image: "/assets/productimages/carpettiles.jpg",
                  use: "Soft floor covering",
                  details: "50x50cm, 10-pack",
                  price: ""
                }
              ]
            },
            hard_tiles: {
              name: "Hard Floor Tiles",
              products: [
                {
                  name: "Porcelain Floor Tiles",
                  image: "/assets/productimages/floortiles.jpg",
                  use: "Hard floor covering",
                  details: "60x60cm, PEI 4 rating",
                  price: ""
                }
              ]
            },
            architectural: {
              name: "Architectural Ceramics",
              products: [
                {
                  name: "3D Facade Tiles",
                  image: "/assets/productimages/architecturaltiles.jpg",
                  use: "Specialty surface covering",
                  details: "Exterior grade ceramic",
                  price: ""
                }
              ]
            }
          }
        },
        flooring: {
          name: "Flooring",
          options: {
            laminate: {
              name: "Laminate Flooring",
              products: [
                {
                  name: "Oak Effect Laminate",
                  image: "/assets/productimages/laminateflooring.jpg",
                  use: "Durable floor covering",
                  details: "12mm thick, AC4 rated, 10-pack",
                  price: ""
                }
              ]
            },
            wood: {
              name: "Real Wood Flooring",
              products: [
                {
                  name: "Engineered Oak Flooring",
                  image: "/assets/productimages/oakflooring.jpg",
                  use: "Premium floor covering",
                  details: "15mm thick with 4mm oak veneer",
                  price: ""
                }
              ]
            },
            epoxy: {
              name: "Epoxy Flooring",
              products: [
                {
                  name: "Industrial Epoxy Coating",
                  image: "/assets/productimages/epoxyflooring.webp",
                  use: "Industrial floor coating",
                  details: "2-part epoxy system, 10kg kit",
                  price: ""
                }
              ]
            }
          }
        },
        // air_circulation: {
        //   name: "Air Circulation",
        //   options: {
        //     fans: {
        //       name: "Fans and Extractors",
        //       images: ["/assets/productimages/fans.jpg"],
        //       products: [
        //         {
        //           name: "Industrial Extractor Fan",
        //           image: "/assets/exhaustfans/fan1.png",
        //           use: "Air circulation systems",
        //           details: "High-capacity ventilation fan",
        //           price: "$149.99"
        //         },
        //         {
        //           name: "Axial fan REST D100 mesh back valve ERA",
        //           image: "/assets/exhaustfans/fan2.png",
        //           use: "Ventilation systems",
        //           details: "High-efficiency axial fan with back-draught valve",
        //           price: "$129.99"
        //         },
        //         {
        //           name: "Axial fan WIND D100 back-draught valve",
        //           image: "/assets/exhaustfans/fan3.png",
        //           use: "Ventilation systems",
        //           details: "Compact axial fan with back-draught valve for improved airflow",
        //           price: "$139.99"
        //         },
        //         {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan4.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         },
        //         {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan5.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         }, {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan6.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         },
        //         {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan7.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         }, {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan8.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         }, {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan9.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         },

        //         {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan10.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         }, {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan11.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         }, {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan12.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         },
        //         {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan13.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         }, {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan14.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         },
        //       ]
        //     }
        //   }
        // },
      }
    }
  };

  // Helpers
  const handleCategoryClick = (categoryKey) => {
    setActiveCategory(categoryKey);
    setActiveSubcategory(null);
    setActiveOption(null);
  };

  const handleSubcategoryClick = (subcategoryKey) => {
    setActiveSubcategory(subcategoryKey);
    setActiveOption(null);
  };

  const handleOptionClick = (optionKey) => {
    setActiveOption(optionKey);
  };

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  };

  // Render functions
  const renderCategoryTabs = () => (
   <div className="flex flex-wrap gap-2 border-b border-gray-200 mb-6 justify-center md:justify-start">
      {Object.entries(tiling_flooring).map(([key, category]) => (
        <button
          key={key}
          className={`px-4 py-2 font-medium text-sm md:text-base ${activeCategory === key
            ? "border-b-2 border-blue-500 text-blue-600"
            : "text-gray-500 hover:text-gray-700"
            }`}
          onClick={() => handleCategoryClick(key)}
        >
          {category?.name ?? "Unnamed Category"}
        </button>
      ))}
    </div>
  );

  const renderSubcategories = () => {
    const category = tiling_flooring?.[activeCategory];
    if (!category?.subcategories) return null;

    return (
      <div className="mb-3">
        <h2 className="text-lg font-semibold mb-3">Subcategories</h2>
     <div className="flex flex-wrap gap-2 justify-center md:justify-start">
          {Object.entries(category.subcategories).map(([key, subcategory]) => (
            <button
              key={key}
              className={`px-3 py-1 rounded-full text-sm ${activeSubcategory === key
                ? "bg-blue-500 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
              onClick={() => handleSubcategoryClick(key)}
            >
              {subcategory?.name ?? "Unnamed Subcategory"}
            </button>
          ))}
        </div>
      </div>
    );
  };

  const renderOptions = () => {
    if (!activeSubcategory) return null;

    const subcategory =
      tiling_flooring?.[activeCategory]?.subcategories?.[activeSubcategory];
    if (!subcategory?.options) return null;

    return (
      <div className="mb-3">
        <h2 className="text-lg font-semibold mb-3">Options</h2>
     <div className="flex flex-wrap gap-2 justify-center md:justify-start">
          {Object.entries(subcategory.options).map(([key, option]) => (
            <button
              key={key}
              className={`px-3 py-1 rounded-full text-sm ${activeOption === key
                ? "bg-blue-500 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
              onClick={() => handleOptionClick(key)}
            >
              {option?.name ?? "Unnamed Option"}
            </button>
          ))}
        </div>
      </div>
    );
  };

  const renderProducts = () => {
    let products = [];

    if (activeSubcategory && activeOption) {
      const option =
        tiling_flooring?.[activeCategory]?.subcategories?.[activeSubcategory]
          ?.options?.[activeOption];
      if (option?.products) {
        products = option.products;
      } else if (option?.options) {
        const nestedOptionKey = Object.keys(option.options)[0];
        products = option?.options?.[nestedOptionKey]?.products ?? [];
      }
    } else if (
      activeSubcategory &&
      tiling_flooring?.[activeCategory]?.subcategories?.[activeSubcategory]
        ?.products
    ) {
      products =
        tiling_flooring?.[activeCategory]?.subcategories?.[activeSubcategory]
          ?.products ?? [];
    }

    if (!products || products.length === 0) {
      return (
        <div className="text-center py-10">
          <p className="text-gray-500">
            Select a category and subcategory to view products
          </p>
        </div>
      );
    }

    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {products.map((product, index) => (
          <div
            key={index}
            className="border rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow cursor-pointer"
            onClick={() => handleProductClick(product)}
          >
            <div className="h-48 bg-gray-200 overflow-hidden">
              <img
                src={product?.image ?? "/placeholder.png"}
                alt={product?.name ?? "Unnamed Product"}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-4">
              <h3 className="font-semibold text-lg mb-2">
                {product?.name ?? "Unnamed Product"}
              </h3>
              <p className="text-gray-600 mb-2">
                {product?.use ?? "No use info"}
              </p>
              {/* <p className="text-blue-600 font-bold">
                {product?.price || "Price not available"}
              </p> */}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderProductModal = () => {
    if (!isModalOpen || !selectedProduct) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
          <div className="p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold">
                {selectedProduct?.name ?? "Unnamed Product"}
              </h2>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700"
              >
                ✖
              </button>
            </div>

            <div className="mb-4">
              <img
                src={selectedProduct?.image ?? "/placeholder.png"}
                alt={selectedProduct?.name ?? "Unnamed Product"}
                className="w-full h-64 object-cover rounded"
              />
            </div>

            <div className="space-y-3">
              <div>
                <h3 className="font-semibold">Uses:</h3>
                <p>{selectedProduct?.use ?? "N/A"}</p>
              </div>

              <div>
                <h3 className="font-semibold">Details:</h3>
                <p>{selectedProduct?.details ?? "N/A"}</p>
              </div>
{/* 
              <div>

                <p className="text-blue-600 font-bold">
                  {selectedProduct?.price || "Price not available"}
                </p>
              </div> */}
            </div>

            <div className="mt-6 flex justify-end">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

return (
    <>
      <ProductsNavRow />
      <div className="container mx-auto px-4 sm:px-6 py-4 w-full max-w-full overflow-x-hidden">
        <h1 className="text-2xl md:text-3xl font-bold mb-4 text-center md:text-left text-gray-800">
          Technical Flooring Products
        </h1>

        {renderCategoryTabs()}
        {renderSubcategories()}
        {renderOptions()}
        {renderProducts()}
        {renderProductModal()}
      </div>
    </>
  )};

export default TilingFlooring;
